import { render, staticRenderFns } from "./applyRecord.vue?vue&type=template&id=6dcb5d80"
import script from "./applyRecord.vue?vue&type=script&lang=js"
export * from "./applyRecord.vue?vue&type=script&lang=js"
import style0 from "./applyRecord.vue?vue&type=style&index=0&id=6dcb5d80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports